import queries from "../helpers/caseQueries";
import Modal from "../Components/modal";

import React, { useState, useMemo, useEffect, useCallback } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { FiEdit, FiTrash2, FiPlus } from "react-icons/fi";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { withUser } from "../Contexts/user";
import { useSidebar } from "../Contexts/sidebar";
import moment from "moment";
import AsyncSelect from "react-select/async";
import { useApolloClient } from "@apollo/react-hooks";


let timerId;



const planOptions = [
    { value: "ul", label: "Unit Linked" },
    { value: "tl", label: "Traditional" }
];

const methodOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "halfyearly", label: "Half Yearly" },
    { value: "yearly", label: "Yearly" }
];

const statusOptions = [
    { value: "all", label: "All" },
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" },
    {
        label: "Disabled",
        value: "disabled", 
    },
];

const Terms = ({ user }) => {
    const { isDarkMode } = useSidebar();
    const [modalData, setModalData] = useState({});
    const [editModalState, setEditModalState] = useState(false);
    const [createModalState, setCreateModalState] = useState(false);

    const [paginationState, setPaginationState] = useState({
        limit: 30,
        page: 1,
        dir: "desc",
        by: "_id",
        totalPages: 0,
        documents: 0
    });

    const initialFilters = useMemo(
        () => ({
            plan: undefined,
            method: undefined,
            status: "active",
            term: undefined,
            amount: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            inforceDate: undefined,
            inforceFrom: undefined,
            inforceTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
            ...(user.auth.type !== "superadmin" && {
                mdgAgent: {
                    label: user.auth.name,
                    value: user.auth.userId,
                },
            }),
        }),
        [user.auth.name, user.auth.type, user.auth.userId]
    );
    const [filters, setFilters] = useState(initialFilters);

    const [formKey, setFormKey] = useState(0);

    const initialAppliedSearchVariables = useMemo(
        () => ({
            plan: undefined,
            method: undefined,
            status: "active",
            term: undefined,
            amount: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            inforceDate: undefined,
            inforceFrom: undefined,
            inforceTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
            mdgAgent: user.auth.type !== "superadmin" ? user.auth.userId : null,
        }),
        [user.auth.type, user.auth.userId]
    );
    const [appliedSearchVariables, setAppliedSearchVariables] = useState(
        initialAppliedSearchVariables
    );

    const handleSearch = () => {
        setAppliedSearchVariables({
            plan: filters.plan,
            method: filters.method,
            status: filters.status === "all" ? undefined : filters.status,
            term: filters.term,
            amount: filters.amount,
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            inforceDate: filters.inforceDate,
            inforceFrom: filters.inforceFrom,
            inforceTo: filters.inforceTo,
            submissionFrom: filters.submissionFrom,
            submissionTo: filters.submissionTo,
            mdgAgent: filters.mdgAgent ? filters.mdgAgent.value : null,
        });
        setPaginationState(prev => ({ ...prev, page: 1 }));
    };

    const apollo = useApolloClient();

    const {
        register,
        errors,
        handleSubmit,
        control,
        setValue,
        reset: resetForm,
    } = useForm({
        defaultValues: {
            plan: "",
            amount: "",
            method: "",
            term: "",
            inforceDate: "",
            status: "active"
        },
    });


    const memberSelect = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area ? "#fc8181" : (isDarkMode ? "#4a5568" : "#e2e8f0"),
                backgroundColor: isDarkMode ? "#2d3748" : "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area ? "#fc8181" : (isDarkMode ? "#4a5568" : "#e2e8f0"),
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: isDarkMode ? "#e2e8f0" : "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),

            singleValue: (provided) => ({
                ...provided,
                color: isDarkMode ? "#e2e8f0" : "#64748b",
            }),

            menu: (provided) => ({
                ...provided,
                backgroundColor: isDarkMode ? "#2d3748" : "#ffffff",
                borderColor: isDarkMode ? "#4a5568" : "#e2e8f0",
            }),

            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected 
                    ? (isDarkMode ? "#4a5568" : "#e2e8f0")
                    : state.isFocused 
                    ? (isDarkMode ? "#374151" : "#f7fafc")
                    : (isDarkMode ? "#2d3748" : "#ffffff"),
                color: isDarkMode ? "#e2e8f0" : "#64748b",
                "&:hover": {
                    backgroundColor: isDarkMode ? "#374151" : "#f7fafc",
                },
            }),
        }),
        [errors, isDarkMode]
    );

    useEffect(() => {
        if (editModalState) {
            const {
                plan,
                amount,
                method,
                term,
                inforceDate,
                status
            } = modalData;

            setValue("plan", { value: plan, label: planOptions.find(p => p.value === plan)?.label });
            setValue("amount", amount);
            setValue("method", { value: method, label: methodOptions.find(m => m.value === method)?.label });
            setValue("term", term);
            setValue("inforceDate", moment(Number(inforceDate) || inforceDate).format("YYYY-MM-DD"));
            setValue("status", { value: status, label: statusOptions.find(s => s.value === status)?.label });
        }
    }, [editModalState, modalData, setValue]);

    const selectStyles = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: isDarkMode ? "#4a5568" : "#e2e8f0",
                backgroundColor: isDarkMode ? "#2d3748" : "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
            }),
            placeholder: (provided) => ({
                ...provided,
                color: isDarkMode ? "#a0aec0" : "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),
            container: (provided) => ({
                ...provided,
                color: isDarkMode ? "#e2e8f0" : "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),
            singleValue: (provided) => ({
                ...provided,
                color: isDarkMode ? "#e2e8f0" : "#64748b",
            }),
            menu: (provided) => ({
                ...provided,
                backgroundColor: isDarkMode ? "#2d3748" : "#ffffff",
                borderColor: isDarkMode ? "#4a5568" : "#e2e8f0",
            }),
            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected 
                    ? (isDarkMode ? "#4a5568" : "#e2e8f0")
                    : state.isFocused 
                    ? (isDarkMode ? "#374151" : "#f7fafc")
                    : (isDarkMode ? "#2d3748" : "#ffffff"),
                color: isDarkMode ? "#e2e8f0" : "#64748b",
                "&:hover": {
                    backgroundColor: isDarkMode ? "#374151" : "#f7fafc",
                },
            }),
        }),
        [isDarkMode]
    );

    const {
        data: termsData,
        loading: termsLoading,
        refetch: refetchTerms,
    } = useQuery(queries.FETCH_TERMS, {
        fetchPolicy: "network-only",
        variables: {
            limit: paginationState.limit,
            page: paginationState.page,
            dir: "desc",
            by: "_id",
            plan: appliedSearchVariables.plan,
            method: appliedSearchVariables.method,
            status: appliedSearchVariables.status,
            term: appliedSearchVariables.term,
            amount: appliedSearchVariables.amount,
            dateFrom: appliedSearchVariables.dateFrom,
            dateTo: appliedSearchVariables.dateTo,
            inforceDate: appliedSearchVariables.inforceDate,
            inforceFrom: appliedSearchVariables.inforceFrom,
            inforceTo: appliedSearchVariables.inforceTo,
            submissionFrom: appliedSearchVariables.submissionFrom,
            submissionTo: appliedSearchVariables.submissionTo,
            mdgAgent: appliedSearchVariables.mdgAgent,
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const columns = useMemo(() => {
        const baseColumns = [
            {
                Header: "Agency",
                accessor: "case",
                Cell: ({ value }) => value?.agency?.name || "-"
            },
            {
                Header: "Project",
                accessor: "case",
                Cell: ({ value }) => value?.project?.name || "-"
            },
            {
                Header: "Unit Number",
                accessor: "case",
                Cell: ({ value }) => value?.unitNumber || "-"
            },
            {
                Header: "Policy Number",
                accessor: "policyNumber",
                Cell: ({ value }) => value || "-"
            },
            {
                Header: "Borrower",
                accessor: "borrower",
                Cell: ({ value }) => value?.name || "-"
            },
            {
                Header: "Plan",
                accessor: "plan",
                Cell: ({ value }) => planOptions.find(p => p.value === value)?.label
            },
            {
                Header: "Premium Amount",
                accessor: "amount",
                Cell: ({ value }) => `RM ${value.toLocaleString()}`
            },
            {
                Header: "Payment Method",
                accessor: "method",
                Cell: ({ value }) => methodOptions.find(m => m.value === value)?.label
            },
            {
                Header: "Payment Term (Years)",
                accessor: "term"
            },
            {
                Header: "Submission Date",
                accessor: "createdAt",
                Cell: ({ value }) => moment(value).format("DD-MM-YYYY")
            },
            {
                Header: "Inforce Date",
                accessor: "inforceDate",
                Cell: ({ value }) => moment(value).format("DD-MM-YYYY")
            },
            {
                Header: "Auto Send",
                accessor: "autoSend",
                Cell: ({ value }) => (
                    <span className={value === true ? "text-green-600" : "text-red-600"}>
                        {value.charAt(0).toUpperCase() + value.slice(1)}
                    </span>
                )
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value }) => (
                    <span className={value === "active" ? "text-green-600" : "text-red-600"}>
                        {value.charAt(0).toUpperCase() + value.slice(1)}
                    </span>
                )
            }
        ];

        // Only add Actions column for superadmin users
        if (user.auth.type === "superadmin") {
            baseColumns.push({
                Header: "Actions",
                id: "actions",
                Cell: ({ row: { original } }) => (
                    <div className="flex space-x-2">
                        <button
                            onClick={() => {
                                setModalData(original);
                                setEditModalState(true);
                            }}
                            className="p-2 text-blue-400 hover:text-blue-600"
                        >
                            <FiEdit />
                        </button>
                        <button
                            onClick={() => handleDeleteTerm(original._id)}
                            className="p-2 text-blue-400 hover:text-blue-600"
                        >
                            <FiTrash2 />
                        </button>
                    </div>
                )
            });
        }

        return baseColumns;
    }, [user.auth.type]);


    const resetEditModal = () => {
        setEditModalState(false);
        setModalData({});
        resetForm();
    };

    const resetCreateModal = () => {
        setCreateModalState(false);
        setModalData({});
        resetForm();
    };

    const [createTerm] = useMutation(queries.CREATE_TERM);
    const [updateTerm] = useMutation(queries.UPDATE_TERM);
    const [deleteTerm] = useMutation(queries.DELETE_TERM);

    const handleCreateTerm = async (formData) => {
        try {
            
            const result = await createTerm({
                variables: {
                    input: {
                        ...formData,
                        amount: parseFloat(formData.amount),
                        plan: formData.plan ? formData.plan.value : undefined,
                        method: formData.method ? formData.method.value : undefined,
                        inforceDate: moment(formData.inforceDate).format("YYYY-MM-DD"),
                        manualYear: formData.manualYear ? (formData.manualYear).toString() : undefined,
                        case: formData.case ? formData.case.value : undefined,
                        policyNumber: formData.policyNumber ? formData.policyNumber : undefined
                        
                    },
                },
            });

            if (result.data) {
                refetchTerms();
                resetCreateModal();
                alert("Term created successfully");
            }
        } catch (err) {
            alert("Failed to create term");
            console.error(err);
        }
    };

    const handleEditTerm = async (formData) => {
        if (user.auth.type !== "superadmin") {
            alert("You are not authorized to edit terms");
            return;
        }

        try {
            const result = await updateTerm({
                variables: 
                     {
                        _id: modalData._id,
                        amount: formData.amount ? parseFloat(formData.amount) : modalData.amount,
                        term: formData.term ? parseInt(formData.term) : modalData.term,
                        plan: formData.plan ? formData.plan.value : modalData.plan,
                        method: formData.method ? formData.method.value : modalData.method,
                        status: formData.status ? formData.status.value : modalData.status,
                        inforceDate: formData.inforceDate ? moment(formData.inforceDate).format("YYYY-MM-DD") : modalData.inforceDate
                    },
                
            });

            if (result.data) {
                refetchTerms();
                resetEditModal();
                alert("Term updated successfully");
            }
        } catch (err) {
            alert("Failed to update term");
            console.error(err);
        }
    };

    const handleDeleteTerm = async (termId) => {
        if (user.auth.type !== "superadmin") {
            alert("You are not authorized to delete terms");
            return;
        }

        if (!window.confirm("Are you sure you want to delete this term?")) {
            return;
        }

        try {
            const result = await deleteTerm({
                variables: {
                    _id: termId
                }
            });

            if (result.data) {
                refetchTerms();
                alert("Term deleted successfully");
            }
        } catch (err) {
            alert("Failed to delete term");
            console.error(err);
        }
    };

    const loadActiveCases = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_CASES,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                    },
                    fetchPolicy: "network-only",
                });

                callback(
                    result.data.fetchCases.data.map((item) => ({
                        label: item.unitNumber,
                        value: item._id,
                    }))
                );
            }, 500);
        },
        [apollo]
    );

    return (
        <div className={`min-h-screen w-full max-w-full overflow-x-hidden ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
            <div className="px-4 py-8 w-full min-w-0 max-w-full">
            <div className="flex justify-between items-center mb-6">
                <h1 className={`text-2xl font-bold ${isDarkMode ? 'text-white' : ''}`}>Terms</h1>
            </div>
            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow p-4 mb-6 border`} key={formKey}>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Inforce Date
                        </label>
                        <div className="relative">
                            <input
                                className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                    isDarkMode 
                                        ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                        : 'bg-white border-gray-300 text-gray-900'
                                }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.inforceFrom || ''} - ${filters.inforceTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute z-10 mt-1 w-full rounded-lg shadow-lg border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="p-4">
                                    <div className="flex gap-4">
                                        <div>
                                            <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                            <input
                                                type="date"
                                                className={`w-full py-1 px-2 border rounded ${
                                                    isDarkMode 
                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                        : 'bg-white border-gray-300 text-gray-900'
                                                }`}
                                                value={filters.inforceFrom || ''}
                                                onChange={(e) => {
                                                    const value = e.target?.value || '';
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        inforceFrom: value
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                            <input
                                                type="date"
                                                className={`w-full py-1 px-2 border rounded ${
                                                    isDarkMode 
                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                        : 'bg-white border-gray-300 text-gray-900'
                                                }`}
                                                value={filters.inforceTo || ''}
                                                onChange={(e) => {
                                                    const value = e.target?.value || '';
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        inforceTo: value
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            className={`px-3 py-1 text-sm rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                            }`}
                                            onClick={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    inforceFrom: undefined,
                                                    inforceTo: undefined
                                                }));
                                                e.target.closest('.absolute').style.display = 'none';
                                            }}
                                        >
                                            Clear
                                        </button>
                                        <button
                                            className="px-3 py-1 text-sm bg-orange-400 text-white hover:bg-orange-500 rounded"
                                            onClick={(e) => {
                                                e.target.closest('.absolute').style.display = 'none';
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Submission Date
                        </label>
                        <div className="relative">
                            <input
                                className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                    isDarkMode 
                                        ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
                                        : 'bg-white border-gray-300 text-gray-900'
                                }`}
                                type="text"
                                placeholder="Select date range"
                                value={`${filters.submissionFrom || ''} - ${filters.submissionTo || ''}`}
                                onClick={(e) => {
                                    const calendar = e.target.nextElementSibling;
                                    if (calendar) {
                                        calendar.style.display = calendar.style.display === 'none' ? 'block' : 'none';
                                    }
                                }}
                            />
                            <div className={`absolute z-10 mt-1 w-full rounded-lg shadow-lg border ${
                                isDarkMode ? 'bg-gray-800 border-gray-600' : 'bg-white border-gray-200'
                            }`} style={{ display: 'none' }}>
                                <div className="p-4">
                                    <div className="flex gap-4">
                                        <div>
                                            <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>From</div>
                                            <input
                                                type="date"
                                                className={`w-full py-1 px-2 border rounded ${
                                                    isDarkMode 
                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                        : 'bg-white border-gray-300 text-gray-900'
                                                }`}
                                                value={filters.submissionFrom || ''}
                                                onChange={(e) => {
                                                    const value = e.target?.value || '';
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        submissionFrom: value
                                                    }));
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <div className={`text-sm font-medium mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>To</div>
                                            <input
                                                type="date"
                                                className={`w-full py-1 px-2 border rounded ${
                                                    isDarkMode 
                                                        ? 'bg-gray-700 border-gray-600 text-white' 
                                                        : 'bg-white border-gray-300 text-gray-900'
                                                }`}
                                                value={filters.submissionTo || ''}
                                                onChange={(e) => {
                                                    const value = e.target?.value || '';
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        submissionTo: value
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="flex justify-end gap-2 mt-4">
                                        <button
                                            className={`px-3 py-1 text-sm rounded ${
                                                isDarkMode 
                                                    ? 'bg-gray-700 hover:bg-gray-600 text-gray-300' 
                                                    : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
                                            }`}
                                            onClick={(e) => {
                                                setFilters((prev) => ({
                                                    ...prev,
                                                    submissionFrom: undefined,
                                                    submissionTo: undefined
                                                }));
                                                e.target.closest('.absolute').style.display = 'none';
                                            }}
                                        >
                                            Clear
                                        </button>
                                        <button
                                            className="px-3 py-1 text-sm bg-orange-400 text-white hover:bg-orange-500 rounded"
                                            onClick={(e) => {
                                                e.target.closest('.absolute').style.display = 'none';
                                            }}
                                        >
                                            Apply
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Payment Method
                        </label>
                        <Controller
                            as={Select}
                            name="method"
                            control={control}
                            options={methodOptions}
                            styles={selectStyles}
                            isClearable={true}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    method: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Plan Type
                        </label>
                        <Controller
                            as={Select}
                            name="plan"
                            control={control}
                            options={planOptions}
                            styles={selectStyles}
                            isClearable={true}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    plan: selected?.value
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
                    <div>
                        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                            Status
                        </label>
                        <Controller
                            as={Select}
                            name="status"
                            control={control}
                            options={statusOptions}
                            styles={selectStyles}
                            isClearable={true}
                            onChange={([selected]) => {
                                setFilters(prev => ({
                                    ...prev,
                                    status: selected?.value
                                }));
                            }}
                        />
                    </div>

                    <div className="flex h-full items-end gap-2">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className={`px-4 py-2 min-h-[38px] rounded text-white ${
                                isDarkMode
                                    ? "bg-blue-600 hover:bg-blue-500"
                                    : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        >
                            Search
                        </button>
                        <button
                            onClick={() => {
                                setFilters(initialFilters);
                                setAppliedSearchVariables(
                                    initialAppliedSearchVariables
                                );
                                setPaginationState((prev) => ({
                                    ...prev,
                                    page: 1,
                                }));
                                // Reset form fields
                                resetForm();
                                // Force re-render of form to clear dropdowns
                                setFormKey(prev => prev + 1);
                            }}
                            className={`px-4 py-2 min-h-[38px] rounded text-white ${
                                isDarkMode
                                    ? "bg-gray-600 hover:bg-gray-500"
                                    : "bg-gray-500 hover:bg-gray-600"
                            }`}
                        >
                            Reset Filters
                        </button>
                    </div>
                </div>
            </div>

            <div className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white'} rounded-lg shadow border overflow-x-auto w-full min-w-0 max-w-full`}>
                {termsLoading ? (
                    <div className="flex flex-col items-center justify-center py-24 px-4">
                        <div className="relative w-16 h-16 mb-4">
                            <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                            <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                        </div>
                        <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                            Loading terms...
                        </p>
                        <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                            Please wait
                        </p>
                    </div>
                ) : (
                <>
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className={`text-black`}>
                    <tr className="bg-orange-400">
                            {columns.map((column) => (
                                <th
                                    key={column.Header}
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider whitespace-nowrap`}
                                >
                                    {column.Header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className={`${isDarkMode ? 'bg-gray-800' : 'bg-white'} divide-y divide-gray-200`}>
                        {termsData?.fetchTerms?.data?.length > 0 ? termsData.fetchTerms.data.map((term) => (
                            <tr key={term._id}>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.case?.agency?.name || "-"}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.case?.project?.name || "-"}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.case?.unitNumber || "-"}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.policyNumber || "-"}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.case?.borrower?.find(b => b._id === term.borrower)?.name || "-"}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{planOptions.find(p => p.value === term.plan)?.label}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>RM {term.amount.toLocaleString()}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{methodOptions.find(m => m.value === term.method)?.label}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.term}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{moment(Number(term.createdAt) || term.createdAt).format("DD-MM-YYYY")}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{moment(Number(term.inforceDate) || term.inforceDate).format("DD-MM-YYYY")}</td>
                                <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>{term.autosend === true ? "Yes" : "No"}</td>
                                <td className="px-6 py-4">
                                    <span className={term.status === "active" ? "text-green-600" : "text-red-600"}>
                                        {term.status.charAt(0).toUpperCase() + term.status.slice(1)}
                                    </span>
                                </td>
                                {user.auth.type === "superadmin" && (
                                    <td className={`px-6 py-4 ${isDarkMode ? 'text-gray-300' : 'text-gray-900'}`}>
                                        <div className="flex space-x-2">
                                            <button
                                                onClick={() => {
                                                    setModalData(term);
                                                    setEditModalState(true);
                                                }}
                                                className={`${isDarkMode ? 'text-orange-400 hover:text-orange-300' : 'text-orange-400 hover:text-orange-600'}`}
                                            >
                                                <FiEdit />
                                            </button>
                                            <button
                                                onClick={() => handleDeleteTerm(term._id)}
                                                className={`p-2 ${isDarkMode ? 'text-orange-400 hover:text-orange-300' : 'text-orange-400 hover:text-orange-600'}`}
                                            >
                                                <FiTrash2 />
                                            </button>
                                        </div>
                                    </td>
                                )}
                            </tr>
                        )) : (
                            <tr>
                                <td
                                    colSpan={user.auth.type === "superadmin" ? 14 : 13}
                                    className={`px-6 py-4 text-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}
                                >
                                    No terms found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {termsData && termsData.fetchTerms.pagination && (
                    <div className={`px-4 py-3 flex items-center justify-between border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                        <div className="flex-1 flex justify-between items-center">
                            <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                                Showing{' '}
                                <span className="font-medium">
                                    {((paginationState.page - 1) * paginationState.limit) + 1}
                                </span>
                                {' '}-{' '}
                                <span className="font-medium">
                                    {Math.min(paginationState.page * paginationState.limit, termsData.fetchTerms.pagination.documents)}
                                </span>
                                {' '}of{' '}
                                <span className="font-medium">{termsData.fetchTerms.pagination.documents}</span>
                                {' '}results
                            </div>
                            <div className="flex space-x-2">
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? (isDarkMode ? 'bg-gray-700 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed')
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    First
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page - 1 }))}
                                    disabled={paginationState.page === 1}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === 1
                                            ? (isDarkMode ? 'bg-gray-700 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed')
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Previous
                                </button>
                                <span className={`px-3 py-1 ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-100 text-gray-900'} rounded-md text-sm font-medium`}>
                                    Page {paginationState.page} of {termsData.fetchTerms.pagination.totalPages}
                                </span>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: prev.page + 1 }))}
                                    disabled={paginationState.page === termsData.fetchTerms.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === termsData.fetchTerms.pagination.totalPages
                                            ? (isDarkMode ? 'bg-gray-700 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed')
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Next
                                </button>
                                <button
                                    onClick={() => setPaginationState(prev => ({ ...prev, page: termsData.fetchTerms.pagination.totalPages }))}
                                    disabled={paginationState.page === termsData.fetchTerms.pagination.totalPages}
                                    className={`px-3 py-1 rounded-md text-sm font-medium ${
                                        paginationState.page === termsData.fetchTerms.pagination.totalPages
                                            ? (isDarkMode ? 'bg-gray-700 text-gray-500 cursor-not-allowed' : 'bg-gray-100 text-gray-400 cursor-not-allowed')
                                            : "bg-orange-400 text-white hover:bg-blue-600"
                                    }`}
                                >
                                    Last
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                </>
                )}
            </div>

            {editModalState && (
                <Modal reset={resetEditModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className={`panel ${isDarkMode ? 'bg-gray-800' : 'bg-white'} p-6 rounded-md max-w-5xl w-full`}>
                            <div className={`mb-4 text-2xl font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Edit Term</div>
                            <form onSubmit={handleSubmit(handleEditTerm)}>
                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                        Plan Type
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="plan"
                                        control={control}
                                        rules={{ required: true }}
                                        options={planOptions}
                                        styles={selectStyles}
                                    />
                                    {errors.plan && (
                                        <p className="text-red-500 text-xs italic">
                                            Plan type is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                        Amount
                                    </label>
                                    <input
                                        type="number"
                                        className={`my-2 p-3 w-full rounded-lg block ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-cool-gray text-lynch'} border font-semibold text-xs ${
                                            errors.amount ? "border-red-400" : (isDarkMode ? "border-gray-600" : "border-gray-300")
                                        }`}
                                        name="amount"
                                        ref={register({ required: true })}
                                        placeholder="Amount"
                                    />
                                    {errors.amount && (
                                        <p className="text-red-500 text-xs italic">
                                            Amount is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                        Payment Method
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="method"
                                        control={control}
                                        rules={{ required: true }}
                                        options={methodOptions}
                                        styles={selectStyles}
                                    />
                                    {errors.method && (
                                        <p className="text-red-500 text-xs italic">
                                            Payment method is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                    Payment Term (Years)
                                    </label>
                                    <input
                                        type="number"
                                        className={`my-2 p-3 w-full rounded-lg block ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-cool-gray text-lynch'} border font-semibold text-xs ${
                                            errors.term ? "border-red-400" : (isDarkMode ? "border-gray-600" : "border-gray-300")
                                        }`}
                                        name="term"
                                        ref={register({ required: true })}
                                        placeholder="Term in years"
                                    />
                                    {errors.term && (
                                        <p className="text-red-500 text-xs italic">
                                            Term is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                        Inforce Date
                                    </label>
                                    <input
                                        type="date"
                                        className={`my-2 p-3 w-full rounded-lg block ${isDarkMode ? 'bg-gray-700 text-gray-300' : 'bg-cool-gray text-lynch'} border font-semibold text-xs ${
                                            errors.inforceDate ? "border-red-400" : (isDarkMode ? "border-gray-600" : "border-gray-300")
                                        }`}
                                        name="inforceDate"
                                        ref={register({ required: true })}
                                    />
                                    {errors.inforceDate && (
                                        <p className="text-red-500 text-xs italic">
                                            Inforce date is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className={`block ${isDarkMode ? 'text-gray-300' : 'text-gray-700'} text-sm font-bold mb-2`}>
                                        Status
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="status"
                                        control={control}
                                        rules={{ required: true }}
                                        options={[
                                            { value: "active", label: "Active" },
                                            { value: "inactive", label: "Inactive" }
                                        ]}
                                        styles={selectStyles}
                                    />
                                    {errors.status && (
                                        <p className="text-red-500 text-xs italic">
                                            Status is required
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className={`${isDarkMode ? 'bg-blue-500 hover:bg-blue-600' : 'bg-blue-400 hover:bg-blue-600'} text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline`}
                                >
                                    Update Term
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}

{createModalState && (
                <Modal reset={resetCreateModal}>
                    <div className="container h-full mx-auto flex justify-center items-center">
                        <div className="panel bg-white p-6 rounded-md max-w-5xl w-full">
                            <div className="mb-4 text-2xl font-bold">Create Term</div>
                            <form onSubmit={handleSubmit(handleCreateTerm)}>
                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Plan Type
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="plan"
                                        control={control}
                                        rules={{ required: true }}
                                        options={planOptions}
                                        styles={selectStyles}
                                    />
                                    {errors.plan && (
                                        <p className="text-red-500 text-xs italic">
                                            Plan type is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Amount (Yearly)
                                    </label>
                                    <input
                                        type="number"
                                        className={`my-2 p-3 w-full rounded-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                            errors.amount ? "border-red-400" : "border-gray-300"
                                        }`}
                                        name="amount"
                                        ref={register({ required: true })}
                                        placeholder="Amount"
                                    />
                                    {errors.amount && (
                                        <p className="text-red-500 text-xs italic">
                                            Amount is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Payment Method
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="method"
                                        control={control}
                                        rules={{ required: true }}
                                        options={methodOptions}
                                        styles={selectStyles}
                                    />
                                    {errors.method && (
                                        <p className="text-red-500 text-xs italic">
                                            Payment method is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Payment Term (Years)
                                    </label>
                                    <input
                                        type="number"
                                        className={`my-2 p-3 w-full rounded-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                            errors.term ? "border-red-400" : "border-gray-300"
                                        }`}
                                        name="term"
                                        ref={register({ required: true })}
                                        placeholder="Term in years"
                                    />
                                    {errors.term && (
                                        <p className="text-red-500 text-xs italic">
                                            Term is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Inforce Date
                                    </label>
                                    <input
                                        type="date"
                                        className={`my-2 p-3 w-full rounded-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                            errors.inforceDate ? "border-red-400" : "border-gray-300"
                                        }`}
                                        name="inforceDate"
                                        ref={register({ required: true })}
                                    />
                                    {errors.inforceDate && (
                                        <p className="text-red-500 text-xs italic">
                                            Inforce date is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Case
                                    </label>
                                    <Controller
                                                as={
                                                    <AsyncSelect
                                                        styles={memberSelect}
                                                    />
                                                }
                                                name="case"
                                                control={control}
                                                rules={{ required: true }}
                                                loadOptions={loadActiveCases}
                                            />
                                    {errors.case && (
                                        <p className="text-red-500 text-xs italic">
                                            Case is required
                                        </p>
                                    )}
                                </div>

                                <div className="mb-4">
                                    <label className="block text-gray-700 text-sm font-bold mb-2">
                                        Manual Year
                                    </label>
                                    <input
                                        type="number"
                                        className={`my-2 p-3 w-full rounded-lg block bg-cool-gray border font-semibold text-lynch text-xs ${
                                            errors.manualYear ? "border-red-400" : "border-gray-300"
                                        }`}
                                        name="manualYear"
                                        ref={register({ required: true })}
                                    />
                                    {errors.manualYear && (
                                        <p className="text-red-500 text-xs italic">
                                            Manual year is required
                                        </p>
                                    )}
                                </div>

                                <button
                                    type="submit"
                                    className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                >
                                    Create Term
                                </button>
                            </form>
                        </div>
                    </div>
                </Modal>
            )}
            </div>
        </div>
    );
};

export default withUser(Terms);
